import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommCrossCircleIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M8.03769 6.97703C7.7448 6.68414 7.26992 6.68414 6.97703 6.97703C6.68414 7.26992 6.68414 7.7448 6.97703 8.03769L10.6893 11.75L6.97703 15.4623C6.68414 15.7552 6.68414 16.2301 6.97703 16.523C7.26992 16.8159 7.7448 16.8159 8.03769 16.523L11.75 12.8107L15.4623 16.523C15.7552 16.8159 16.2301 16.8159 16.523 16.523C16.8159 16.2301 16.8159 15.7552 16.523 15.4623L12.8107 11.75L16.523 8.03769C16.8159 7.7448 16.8159 7.26992 16.523 6.97703C16.2301 6.68414 15.7552 6.68414 15.4623 6.97703L11.75 10.6893L8.03769 6.97703Z"
            fill="#222"
          />
          <path
            d="M1 11.75C1 5.81294 5.81294 1 11.75 1C17.6871 1 22.5 5.81294 22.5 11.75C22.5 17.6871 17.6871 22.5 11.75 22.5C5.81294 22.5 1 17.6871 1 11.75ZM11.75 2.5C6.64137 2.5 2.5 6.64137 2.5 11.75C2.5 16.8586 6.64137 21 11.75 21C16.8586 21 21 16.8586 21 11.75C21 6.64137 16.8586 2.5 11.75 2.5Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
